<template>
<div class="add_box">
   <!-- 车牌号 -->
  <card-number come="add" @inputChange="inputChange" :mustImg="mustImg"></card-number>
  <common-footer text="添加" :canClick="canClick" @btnClick="btnClick"></common-footer>
</div>
</template>

<script>
import CommonFooter from '../../components/footer';
import CardNumber from './components/cardNumber';
import util from '../../utils/util';
import {approvalMixin} from '../../utils/approvalMixin';
import storage from '../../utils/storage';
import {loadParkHeaderById,spaceUpPcHttp} from '../../utils/api';
import {mapState} from 'vuex';
export default {
  name: 'addCardNumber',
  props: {},
  mixins:[approvalMixin],
  components: {
    CommonFooter,
    CardNumber
  },
  filters: {
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      approvalProcessTime:0,//发起流程次数
      startInstanceTime:0,//发起审批次数
      html:'',
      canClick:false,
      cardList:[],
      changeTargetIdUrl:spaceUpPcHttp+'/syscfg/attachmentTerminal/bindSomeAttachments',
      plateNo:'',//车牌号
      timemap:'',
      mustImg:2,
      hex_md5_return:''
    }
  },
  created() {
    this.mustImg = Number(storage.getS("mustImg")) || 2//是否必传图片 1是，2否
  },
  mounted(){

  },
  methods: {
    resetSign(){
      // 公钥+私钥+时间戳+平台
      let gong = 'vanke2019spaceup009'
      let si = '009vanke2019spaceup001'
      this.timemap = new Date().getTime()
      let platfrom = 'SaasMobile'
      let str = gong+si+this.timemap+platfrom
      this.hex_md5_return = this.$md5(str)
    },
    inputChange(val){
      if(val.type == 'card'){
        let cardList = val.data;
        this.cardList = cardList;
        this.plateNo = cardList[0].cardNumber
      }
      if(!this.plateNo){
        this.canClick = false
      }else{
        this.canClick = true
      }
    },
    btnClick(){
      if(this.mustImg == 1){
        let status = true;
        this.cardList.forEach(item=>{
          if(item.fileList.length == 0){
            status = false;
          }
        })
        if(!status){
          util.showToast("请上传车牌图片")
          return false;
        }
      }
      util.showLoading()
      let params = {
        "parkLotId": this.$route.query.parkLotId,
        "plateNo": this.plateNo,
        "url": "/parking/rstParkLot/applayPlateNo"
      }
      loadParkHeaderById(params).then(res=>{
       
        if(res.res.code === 10000 && res.body){
          this.changeTarget(res.body.data.bsid)
          // 申请待办
          if(res.body.data.applyStatus ==1){
            this.approvalProcess(res.body.data,()=>{
              this.$router.go(-1)
              storage.setS("isNeedFresh",true)
            },()=>{
              util.hideLoading()
              util.showToast('提交失败')
            })
          }else{
            this.$router.go(-1)
            storage.setS("isNeedFresh",true)
          }
        }else{
          util.hideLoading()
          util.showToast(res.res.msg)
        }
      })
    },
    changeTarget(id){
      let self = this;
      this.resetSign()
      fetch(self.changeTargetIdUrl, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          "Access-channel": "saas_rst",
          "companyId":self.common.marketInfo.cityId
        },
        body: JSON.stringify({
          'newTarget': id,
          'oldTarget': this.cardList[0].targetId,
          'bizCode': 'TCP',
          'platform': 'SaasMobile',
          'timestamp': self.timemap,
          'sign':self.hex_md5_return,
          'companyId':self.common.marketInfo.cityId
        })
      }).then(response => response.json()).then(() => {

      })
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.add_box{
  background:#eee;
}
</style>
